import { isPlatformBrowser } from '@angular/common';
import * as Rx from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@nguniversal/express-engine/tokens";
/*
 * Reactive & server-side friendly version of window.location
 */
var Location = /** @class */ (function () {
    function Location(platformId, request, response) {
        this.platformId = platformId;
        this.request = request;
        this.response = response;
        this.routeLoaded = false;
        this.locationSubject$ = new Rx.ReplaySubject(1);
    }
    /*
     * Emits a stream of LocationEvent
     */
    Location.prototype.valueChanges = function () {
        return this.locationSubject$.asObservable();
    };
    /**
     * Sets the location to a provided url leaving the angular shell.
     */
    Location.prototype.redirect = function (url) {
        if (isPlatformBrowser(this.platformId)) {
            if (this.routeLoaded) {
                window.location.assign(url);
            }
            else {
                window.location.replace(url);
            }
        }
        else {
            this.response.redirect(url);
        }
        return Rx.NEVER;
    };
    Object.defineProperty(Location.prototype, "origin", {
        /*
         * Returns the current origin in a platform friendly way
         */
        get: function () {
            if (isPlatformBrowser(this.platformId)) {
                return window.location.origin;
            }
            return this.request.protocol + "://" + this.hostname;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "hostname", {
        /*
         * Returns the current hostname in a platform friendly way
         */
        get: function () {
            if (isPlatformBrowser(this.platformId)) {
                return window.location.hostname;
            }
            // FIXME: we should be using `req.hostname` here but Express incorrectly
            // strips off the port number, which breaks local dev. This has been fixed
            // in Express 5 -> https://expressjs.com/en/guide/migrating-5.html#req.host
            return (this.request.get('X-Forwarded-Host') ||
                this.request.get('Host'));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "href", {
        /*
         * Returns the current (absolute) URL in a platform friendly way
         */
        get: function () {
            if (isPlatformBrowser(this.platformId)) {
                return window.location.href;
            }
            return "" + this.origin + this.request.originalUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Location.prototype, "url", {
        /*
         * Returns the current URL in a platform friendly way
         */
        get: function () {
            if (isPlatformBrowser(this.platformId)) {
                return "" + window.location.pathname + window.location.search;
            }
            return this.request.originalUrl;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * [PRIVATE] Exported private API.
     * To be used only by the LocationComponent to push new locations
     */
    Location.prototype._setLocation = function (pathname) {
        this.locationSubject$.next({
            hash: '',
            hostname: this.hostname,
            href: "" + this.origin + pathname,
            origin: this.origin,
            pathname: pathname,
            search: '',
        });
    };
    /**
     * [PRIVATE] exported private API
     * To be used only by the LocationComponent to mark that routes are loaded
     */
    Location.prototype._routeHasLoaded = function () {
        this.routeLoaded = true;
    };
    Location.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Location_Factory() { return new Location(i0.ɵɵinject(i0.PLATFORM_ID), i0.ɵɵinject(i1.REQUEST, 8), i0.ɵɵinject(i1.RESPONSE, 8)); }, token: Location, providedIn: "root" });
    return Location;
}());
export { Location };
